import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data?.data
}

const searchTxnsReq = (req: any, tokens: any, abortController?: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.searchTxns),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens, abortController),
    headers: getHeaders(),
    body: req,
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { searchTxnsReq }
